// extracted by mini-css-extract-plugin
module.exports = {"creditPointsTag":"creditPointsTag_creditPointsTag__3oW7n","condense":"creditPointsTag_condense__3tHrI","in":"creditPointsTag_in__2ZooD","out":"creditPointsTag_out__H2_Z1"};